import React from 'react'
import tecsinapse from '@web/assets/tecsinapse.png'
import { wingoSetupVariants } from '@web/modules/wingo-setup/styles'
import { useWingoSetup } from '@web/modules/wingo-setup/hooks'
import { Button, Loading } from '@tecsinapse/cortex-react'

const { container, image, form, formContainer, title, subtitle, button } = wingoSetupVariants()
const WingoSetup = () => {
  const { handleLogin, submitting } = useWingoSetup()

  return (
    <div className={container()}>
      <div className={image()}>
        <img
          className='mr-4'
          src={tecsinapse}
          alt='tecsinapse-logo'
        />
      </div>
      <div className={form()}>
        <div className={formContainer()}>
          <p className={title()}>Bem-vindo a plataforma Wingo</p>
          <p className={subtitle()}>
            Para dar início ao processo de implantação do Wingo Chat,
            <br /> conecte-se a sua conta Whatsapp Business e prossiga com as instruções apresentadas.
          </p>
          <Button
            className={button()}
            variants={{ variant: 'text' }}
            disabled={submitting}
            onClick={handleLogin}
          >
            <div>{submitting ? <Loading className={'flex items-center'} /> : 'Login com Facebook'}</div>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default WingoSetup
